import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 7l6 6l4 -4l8 8","key":"svg-0"}],["path",{"d":"M21 10l0 7l-7 0","key":"svg-1"}]]

/**
 * IconTrendingDown
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItdHJlbmRpbmctZG93biIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNMyA3bDYgNmw0IC00bDggOCIgLz4KICA8cGF0aCBkPSJNMjEgMTBsMCA3bC03IDAiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/trending-down
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconTrendingDown = createReactComponent('outline', 'trending-down', 'TrendingDown', __iconNode);

export default IconTrendingDown;